import React from 'react';

const SleighMarkers = () => (
		<>
			<g transform="translate(1565, 1094)">
				<rect stroke="#E6A6F3" strokeWidth="2" fill="#BD10E0" x="-1" y="-1" width="18"
							height="18" rx="9"/>
				<g transform="translate(3.386908, 4.507557)">
					<path
						d="M0,5.72833056 L7.765,5.72833056 C8.94175,5.72833056 9.89575,4.77458056 9.89575,3.59783056 L9.89575,3.23008056"
						id="Stroke-1" stroke="#FFFFFF" strokeLinejoin="round"/>
					<line x1="1.7423" y1="3.36260556" x2="1.7423" y2="5.58460556" id="Stroke-3" stroke="#FFFFFF"
								strokeLinejoin="round"/>
					<line x1="6.8069" y1="3.36260556" x2="6.8069" y2="5.58460556" id="Stroke-5" stroke="#FFFFFF"
								strokeLinejoin="round"/>
					<path
						d="M1.40932795,0.357396973 C2.27643992,0.357396973 3.0989358,0.734718901 3.66395554,1.38838872 L3.71959137,1.45467312 L5.1358671,2.95048435 L7.99432795,2.95073435 L7.99432795,3.78189697 L0.505077955,3.78189697 C0.376868995,3.78189697 0.271201165,3.68538693 0.256759888,3.56105225 L0.255077955,3.53189697 L0.255077955,0.607396973 C0.255077955,0.479188013 0.351588002,0.373520183 0.475922673,0.359078906 L0.505077955,0.357396973 L1.40932795,0.357396973 Z"
						id="Path" fill="#FFFFFF" fillRule="nonzero"/>
				</g>
			</g>

			<g transform="translate(1615, 1160)">
				<rect stroke="#E6A6F3" strokeWidth="2" fill="#BD10E0" x="-1" y="-1" width="18" height="18" rx="9"/>
				<g transform="translate(3.386908, 4.507557)">
					<path
						d="M0,5.72833056 L7.765,5.72833056 C8.94175,5.72833056 9.89575,4.77458056 9.89575,3.59783056 L9.89575,3.23008056"
						stroke="#FFFFFF" strokeLinejoin="round"/>
					<line x1="1.7423" y1="3.36260556" x2="1.7423" y2="5.58460556" id="Stroke-3" stroke="#FFFFFF"
								strokeLinejoin="round"/>
					<line x1="6.8069" y1="3.36260556" x2="6.8069" y2="5.58460556" id="Stroke-5" stroke="#FFFFFF"
								strokeLinejoin="round"/>
					<path
						d="M1.40932795,0.357396973 C2.27643992,0.357396973 3.0989358,0.734718901 3.66395554,1.38838872 L3.71959137,1.45467312 L5.1358671,2.95048435 L7.99432795,2.95073435 L7.99432795,3.78189697 L0.505077955,3.78189697 C0.376868995,3.78189697 0.271201165,3.68538693 0.256759888,3.56105225 L0.255077955,3.53189697 L0.255077955,0.607396973 C0.255077955,0.479188013 0.351588002,0.373520183 0.475922673,0.359078906 L0.505077955,0.357396973 L1.40932795,0.357396973 Z"
						fill="#FFFFFF" fillRule="nonzero"/>
				</g>
			</g>
		</>
	)
;

export default SleighMarkers;
